export enum COUPON_TYPE {
  COUPON = 'coupon',
  OFFER = 'offer',
}

export const COUPON_PAGE_TYPE = {
  COUPON_LISTING_TYPE: 'couponListingPage',
  OFFER_LISTING_TYPE: 'offerListingPage',
};

export enum DELTA_COMM_STATUS {
  APPLIED = 'APPLIED',
  NON_APPLIED = 'NON_APPLIED',
  APPLICABLE = 'APPLICABLE',
}

export enum COUPON_STATUS {
  APPLIED = 'APPLIED',
  APPLICABLE = 'APPLICABLE',
  NON_APPLICABLE = 'NON_APPLICABLE',
}

export interface CouponDetails {
  imageUrl: string;
  couponCode: string;
  couponStatus: COUPON_STATUS;
}

export enum COUPON_INTERACTION_LOCATION {
  PDP = 'productpage',
  CART = 'cartpage',
  COUPON_PAGE = 'coupon_page',
  PRODUCT_PAGE_COUPON_BS = 'productpage:coupon:BS',
  CART_PAGE_COUPON_BS = 'cartpage:coupon:BS',
  PRODUCT_PAGE_OFFER_BS = 'productpage:offer:BS',
  CART_PAGE_OFFER_BS = 'cartpage:coupon:BS',
  CART_PAGE = 'cart_page',
  CART_PAGE_CAUTION_BS = 'cart_page:cautionbs',
  CART_PAGE_REPLACE_BS = 'cart_page:replacebs',
  CART_PAGE_L2 = 'cartPage',
}

export interface Coupon {
  couponCode: string;
  couponId: number;
  couponTag?: string | null;
  title: string;
  subTitle: string;
  description: string;
  couponType: number;
  deltaCouponDTO: null;
  discount: number;
  fromDate: string;
  headingText: string;
  couponDetails: CouponDetails;
  infiniteUsage: true;
  label: string;
  offerId: number;
  offerType: string;
  prive: boolean;
  subText: string;
  timesUsed: number;
  toDate: string;
  usesPerCustomer: number;
  expiryEpoch?: number;
  viewProductsFlag?: boolean;
  imageUrl?: string;
  deltaTextModified: string;
  status: DELTA_COMM_STATUS;
  deltaAmount: string;
}

export interface CouponDetails {
  // from api
  couponCode: string;
  couponId: number;
  title: string;
  subTitle: string;
  description: string;
  couponTncUrl: string;
  freebies: any[];
  imageUrl: string;
  prive: boolean;
  subtitle: string;
  tnc: string[];
  // added on code level
  discount: number;
  disabled: boolean;
  expiryEpoch?: number;
  deltaTextModified?: string;
  deltaAmount: string;
  deltaQuantity: string;
  status: string;
  fundingType: string;
  deltacomType: string;
  deltaCouponDTO: { deltaText: string };
  offerId: number;
  viewProductsFlag: boolean;
  showViewProduct?: boolean;
}

export interface CouponsList {
  applicableCoupons: Coupon[];
  nonApplicableCoupons: Coupon[];
  appliedCoupon: Coupon[];
}

export interface OfferDetails {
  // from api
  offerId: number;
  title: string;
  description: string;
  label?: string;
  offerDiscount?: string;
  expiryEpoch?: number;
  deltaTextModified?: string;
  deltaAmount: string;
  deltaQuantity: string;
  status: string;
}

export interface BestCouponCombination {
  couponCode: string;
  title: string;
  discountAmount: number | null;
  expiryEpoch: number;
  forFirstOrderOnly: boolean;
  couponTag: string | null;
  couponStatus: COUPON_STATUS;
  urgencyTimerLapse: number;
}

export interface BestOffer {
  offerId: number;
  title: string;
  description: string;
  imageUrl: 'string';
  offerType: string;
  expiryEpoch: number;
  offerDiscount: number;
  offerBestPrice: number;
  label: string;
  couponCode: string;
  couponId: string;
  discountType: COUPON_TYPE;
  expiry: string;
  future: boolean;
  isViewProducts: boolean;
}

export interface ApplyCouponCode {
  couponCode: string;
  isCouponCodeEnteredManually: boolean;
  bestCouponTag?: string;
}

export interface ApplyCouponCodeRemove {
  couponCode: string;
  isRemovedManually: boolean;
  bestCouponTag?: string;
  interactionLocation?: string;
}
